// auth strings (ar).
// Machine-drafted — review with a native speaker before launch.
const auth = {
	auth: {
		// Titles & headings
		signInTitle: 'سجّل الدخول إلى حسابك',
		signUpTitle: 'إنشاء حساب جديد',
		signUpToAccount: 'أنشئ حسابك',
		resetYourPassword: 'إعادة تعيين كلمة المرور',

		// Links & secondary actions
		or: 'أو',
		orLower: 'أو',
		orDivider: 'أو',
		createNewAccount: 'إنشاء حساب جديد',
		alreadyHaveAccountLogin: 'لديك حساب بالفعل؟ سجّل الدخول',
		alreadyHaveAccount: 'لديك حساب بالفعل؟',
		logIn: 'تسجيل الدخول',
		forgotPassword: 'هل نسيت كلمة المرور؟',

		// Buttons
		signIn: 'تسجيل الدخول',
		signUp: 'إنشاء حساب',
		signInWithGoogle: 'تسجيل الدخول باستخدام Google',
		signUpWithGoogle: 'إنشاء حساب باستخدام Google',
		send: 'إرسال',

		// Field labels & placeholders
		emailAddress: 'البريد الإلكتروني',
		yourEmailAddress: 'بريدك الإلكتروني',
		emailPlaceholder: 'you@example.com',
		enterEmailAddress: 'أدخل بريدك الإلكتروني',
		password: 'كلمة المرور',
		enterPassword: 'أدخل كلمة المرور',
		rememberMe: 'تذكرني',

		// Terms & consent
		agreeToOur: 'بالتسجيل، فإنك توافق على',
		termsOfService: 'شروط الخدمة',
		and: 'و',
		privacyPolicy: 'سياسة الخصوصية',

		// Invitation
		invitedToJoin: 'لقد تمت دعوتك للانضمام إلى مساحة عمل %{workspace}',

		// Testimonials panel
		clientsSayHeading: 'ماذا يقول عملاؤنا عنّا',
		companiesTrust: 'أكثر من 1000 شركة تبني علاقات أفضل باستخدام CardClan',

		// Alerts / dialog titles
		errorTitle: 'خطأ',
		successTitle: 'تم بنجاح',
		oops: 'عذراً!',

		// Alert / validation messages
		passwordResetLinkSent: 'تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني.',
		emailNotRegistered: 'هذا البريد الإلكتروني غير مسجّل.',
		wrongPassword: 'كلمة المرور التي أدخلتها غير صحيحة.',
		unknownError: 'حدث خطأ غير معروف. يرجى التواصل مع الدعم على support@cardclan.io.',
		invalidEmail: 'صيغة البريد الإلكتروني غير صحيحة',
		emailRequired: 'البريد الإلكتروني مطلوب',
		passwordRequired: 'كلمة المرور مطلوبة',
		passwordRules:
			'يجب أن تتكون كلمة المرور من 6 إلى 18 حرفاً، وتتضمن حرفاً كبيراً وحرفاً صغيراً ورقماً واحداً على الأقل.',
	} as Record<string, string>,
};
export default auth;
